import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  controlWrapper: {
    [theme.breakpoints.down(theme.size.sm)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down(theme.size.xs)]: {
      width: '100%',
    },
  },
  selectRoot: {
    [theme.breakpoints.down(theme.size.xs)]: {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  datePicker: {
    [theme.breakpoints.down(theme.size.xs)]: {
      width: '100%',
    },
  },
  value: {
    fontSize: 15,
    fontWeight: 400,
    color: '#fff',
  },
  column: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 20,
    padding: 10,
    '@media (max-width: 1700px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
  },
  flexWrap: {
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  barWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    [theme.breakpoints.down(theme.size.xs)]: {
      width: '100%',
    },
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  label: {
    marginRight: 20,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    [theme.breakpoints.down(theme.size.sm)]: {
      marginRight: 0,
      marginBottom: 10,
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 40,
    '&:last-child': {
      marginRight: 0,
    },
  },
  iframe: {
    height: '100%',
  },
  visuallyHidden: {
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
    width: 1,
    height: 1,
    margin: -1,
  },
  title: {
    margin: 0,
    marginRight: 15,
  },
}));
